"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IconButton_1 = require("@material-ui/core/IconButton");
var Cancel_1 = require("@material-ui/icons/Cancel");
var Check_1 = require("@material-ui/icons/Check");
var ChevronLeft_1 = require("@material-ui/icons/ChevronLeft");
var ChevronRight_1 = require("@material-ui/icons/ChevronRight");
var Close_1 = require("@material-ui/icons/Close");
var Edit_1 = require("@material-ui/icons/Edit");
var Animator_1 = require("../Animator");
var InteractionEvent_1 = require("engine/ui/InteractionEvent");
var Object2D_1 = require("engine/ui/Object2D");
var Rect_1 = require("engine/ui/Rect");
var React = require("react");
var TrackObject_1 = require("../track/TrackObject");
var ReactObject_1 = require("./core/ReactObject");
var Axis_1 = require("./Axis");
var DragMode;
(function (DragMode) {
    DragMode[DragMode["Move"] = 0] = "Move";
    DragMode[DragMode["SelectRegion"] = 1] = "SelectRegion";
})(DragMode || (DragMode = {}));
var Panel = /** @class */ (function (_super) {
    __extends(Panel, _super);
    function Panel(onClose, spacing, panelHeaderHeight, xAxisHeight, dataSource) {
        var _this = _super.call(this) || this;
        _this.onClose = onClose;
        _this.spacing = spacing;
        _this.panelHeaderHeight = panelHeaderHeight;
        _this.xAxisHeight = xAxisHeight;
        _this.maxRange = 1e10;
        _this.minRange = 10;
        _this.clampToTracks = false;
        _this.trackViews = new Set();
        _this._closable = false;
        _this._closing = false;
        _this.x0 = 0;
        _this.x1 = 1;
        _this.activeAxisPointers = {};
        _this.secondaryAxisPointers = {};
        _this.tileDragging = false;
        _this.tileHovering = false;
        _this.isEditing = false;
        _this._dataSourceId = 0;
        _this._rangeAnimationObject = {
            _setRangeInternal: function (x0, x1) { _this.setRangeImmediate(x0, x1); },
            _x0: _this.x0,
            _x1: _this.x1,
            set x0(x) {
                this._x0 = x;
                this._setRangeInternal(this._x0, this._x1);
            },
            set x1(x) {
                this._x1 = x;
                this._setRangeInternal(this._x0, this._x1);
            },
            get x0() { return this._x0; },
            get x1() { return this._x1; },
        };
        _this.onTrackLeave = function (e) {
            _this.tileHovering = false;
            if (!_this.tileDragging) {
                _this.removeActiveAxisPointer(e);
            }
        };
        _this.onTrackPointerMove = function (e) {
            _this.tileHovering = true;
            _this._dragMode = undefined;
            _this.setActiveAxisPointer(e);
        };
        _this.onTrackWheel = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var xScrollDomPx = 0;
            var yScrollDomPx = 0;
            // determine panning delta in dom pixels from horizontal scroll amount
            switch (e.wheelDeltaMode) {
                default:
                case InteractionEvent_1.WheelDeltaMode.Pixel: {
                    xScrollDomPx = e.wheelDeltaX;
                    yScrollDomPx = e.wheelDeltaY;
                    break;
                }
                case InteractionEvent_1.WheelDeltaMode.Line: {
                    // assume a line is roughly 12px (needs experimentation)
                    xScrollDomPx = e.wheelDeltaX * 12;
                    yScrollDomPx = e.wheelDeltaY * 12;
                    break;
                }
                case InteractionEvent_1.WheelDeltaMode.Page: {
                    // assume a page is roughly 1000px (needs experimentation)
                    xScrollDomPx = e.wheelDeltaX * 1000;
                    yScrollDomPx = e.wheelDeltaY * 1000;
                    break;
                }
            }
            // gesture disambiguation; when dominantly zooming we want to reduce panning speed
            // normalize scroll vector
            var scrollVectorLengthSq = xScrollDomPx * xScrollDomPx + yScrollDomPx * yScrollDomPx;
            // avoid divide by 0 normalization issues
            if (scrollVectorLengthSq <= 0) {
                scrollVectorLengthSq = 1;
            }
            var scrollVectorLength = Math.sqrt(scrollVectorLengthSq);
            var normScrollX = xScrollDomPx / scrollVectorLength; // cosAngleY
            var normScrollY = yScrollDomPx / scrollVectorLength; // cosAngleX
            // as normScrollVectorY approaches 1, we should scale xScrollDomPx to
            var absAngleY = Math.acos(Math.abs(normScrollY));
            var fractionalAngleY = 2 * absAngleY / (Math.PI); // 0 = points along y, 1 = points along x
            var absAngleX = Math.acos(Math.abs(normScrollX));
            var fractionalAngleX = 2 * absAngleX / (Math.PI); // 0 = points along x, 1 = points along y
            // use fraction angle to reduce x as angle approaches y-pointing
            // see https://www.desmos.com/calculator/butkwn0xdt for function exploration
            var edge = 0.75;
            var xReductionFactor = Math.sin(Math.pow(Math.min(fractionalAngleY / edge, 1), 3) * (Math.PI / 2));
            var yReductionFactor = Math.sin(Math.pow(Math.min(fractionalAngleX / edge, 1), 3) * (Math.PI / 2));
            xScrollDomPx = xScrollDomPx * xReductionFactor;
            yScrollDomPx = yScrollDomPx * yReductionFactor;
            // compute zoom multiplier from wheel y
            var zoomFactor = 1;
            if (e.ctrlKey) {
                // pinch zoom
                zoomFactor = 1 + e.wheelDeltaY * 0.01; // I'm assuming mac trackpad outputs change in %, @! needs research
            }
            else {
                // scroll zoom
                var scrollZoomSpeed = 0.3;
                zoomFactor = 1 + yScrollDomPx * 0.01 * scrollZoomSpeed;
            }
            var x0 = _this.x0;
            var x1 = _this.x1;
            var span = x1 - x0;
            // apply scale change
            var zoomCenterF = e.fractionX;
            // clamp zoomFactor to range limits
            if (span * zoomFactor > _this.maxRange) {
                zoomFactor = _this.maxRange / span;
            }
            if (span * zoomFactor < _this.minRange) {
                zoomFactor = _this.minRange / span;
            }
            var d0 = span * zoomCenterF;
            var d1 = span * (1 - zoomCenterF);
            var p = d0 + x0;
            x0 = p - d0 * zoomFactor;
            x1 = p + d1 * zoomFactor;
            var newSpan = x1 - x0;
            var midSpan = (newSpan + span) * 0.5;
            // offset by x-scroll
            var basePairsPerPixel = midSpan / _this.getComputedWidth();
            var xScrollBasePairs = basePairsPerPixel * xScrollDomPx;
            x0 = x0 + xScrollBasePairs;
            x1 = x1 + xScrollBasePairs;
            _this.setRange(x0, x1);
        };
        _this.onTrackDragStart = function (e) {
            var e_1, _a;
            _this._dragMode = undefined;
            if (e.buttonState !== 1)
                return;
            // determine drag mode
            if (e.shiftKey) {
                _this._dragMode = DragMode.SelectRegion;
            }
            else {
                // default drag
                _this._dragMode = DragMode.Move;
            }
            // common
            _this._dragXF0 = e.fractionX;
            _this._dragX00 = _this.x0;
            _this._lastDragLX = e.localX;
            _this._dragDistLocal = 0;
            switch (_this._dragMode) {
                case DragMode.SelectRegion: {
                    e.preventDefault();
                    try {
                        for (var _b = __values(_this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var track = _c.value;
                            track.setFocusRegion(_this._dragXF0, _this._dragXF0);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    break;
                }
                case DragMode.Move: {
                    e.preventDefault();
                    _this.tileDragging = true;
                    break;
                }
            }
        };
        _this.onTrackDragMove = function (e) {
            var e_2, _a;
            if (e.buttonState !== 1)
                return;
            _this._dragDistLocal += Math.abs(e.localX - _this._lastDragLX);
            _this._lastDragLX = e.localX;
            switch (_this._dragMode) {
                case DragMode.SelectRegion: {
                    e.preventDefault();
                    // selected region in fractional units
                    var selectedRegionF0 = _this._dragXF0;
                    var selectedRegionF1 = e.fractionX;
                    try {
                        for (var _b = __values(_this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var track = _c.value;
                            track.setFocusRegion(selectedRegionF0, selectedRegionF1);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    break;
                }
                case DragMode.Move: {
                    e.preventDefault();
                    _this.tileDragging = true;
                    var span = _this.x1 - _this.x0;
                    var dxf = e.fractionX - _this._dragXF0;
                    var x0 = _this._dragX00 + span * (-dxf);
                    var x1 = x0 + span;
                    var l = _this.applyLimits(x0, x1);
                    var dlx0 = Math.abs(l.x0 - x0);
                    var dlx1 = Math.abs(l.x1 - x1);
                    if (dlx0 > 0) {
                        x0 = l.x0;
                        x1 = x0 + span;
                    }
                    if (dlx1 > 0) {
                        x1 = l.x1;
                        x0 = x1 - span;
                    }
                    _this.setRange(x0, x1);
                    break;
                }
            }
            // update axis pointer position because we probably prevented default
            _this.setActiveAxisPointer(e);
        };
        _this.onTrackDragEnd = function (e) {
            var e_3, _a;
            e.stopPropagation();
            switch (_this._dragMode) {
                case DragMode.SelectRegion: {
                    e.preventDefault();
                    // determine selected region in absolute units (base pairs)
                    var span = _this.x1 - _this.x0;
                    var selectedRegionX0 = _this.x0 + span * _this._dragXF0;
                    var selectedRegionX1 = _this.x0 + span * e.fractionX;
                    var x0 = Math.min(selectedRegionX0, selectedRegionX1);
                    var x1 = Math.max(selectedRegionX0, selectedRegionX1);
                    // clamp to existing range (so it must be a zoom in)
                    x0 = Math.max(x0, _this.x0);
                    x1 = Math.min(x1, _this.x1);
                    var event_1 = new SelectRegionEvent(_this, _this.contig, x0, x1, Math.min(_this._dragXF0, e.fractionX), Math.max(_this._dragXF0, e.fractionX));
                    _this.emit('panel-event', event_1);
                    if (!event_1.defaultPrevented) {
                        // zoom into region
                        _this.setRange(x0, x1, true);
                    }
                    break;
                }
                case DragMode.Move: {
                    // if total drag distance, preventDefault so that pointerup isn't fired for other nodes
                    if (_this._dragDistLocal > 4) {
                        e.preventDefault();
                    }
                    break;
                }
            }
            try {
                for (var _b = __values(_this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var track = _c.value;
                    track.clearFocusRegion();
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            _this.tileDragging = false;
            if (!_this.tileHovering) {
                _this.removeActiveAxisPointer(e);
            }
            _this._dragMode = undefined;
        };
        _this.availableContigAtOffset = function (contig, offset) {
            if (_this.availableContigs != null) {
                var idx = _this.availableContigs.findIndex(function (c) { return c.id === contig; });
                if (idx < 0)
                    return _this.availableContigs[0].id;
                var newIdx = (idx + offset) % _this.availableContigs.length;
                if (newIdx < 0)
                    newIdx += _this.availableContigs.length;
                return _this.availableContigs[newIdx].id;
            }
            else {
                return _this.contig;
            }
        };
        // a panel has nothing to render on its own
        _this.render = false;
        _this.header = new ReactObject_1.default();
        _this.fillX(_this.header);
        _this.header.h = _this.panelHeaderHeight;
        _this.header.containerStyle = {
            zIndex: 3,
            backgroundColor: '#fff',
        };
        _this.header.originY = -1;
        _this.header.y = -_this.xAxisHeight - _this.spacing.y * 0.5;
        _this.add(_this.header);
        // 1/2 spacing around the x-axis
        var offset = 0.5; // offset labels by 0.5 to center on basepairs
        _this.xAxis = new Axis_1.default({
            x0: _this.x0,
            x1: _this.x1,
            align: 'bottom',
            offset: offset,
            snap: 1,
            startFrom: 1,
            tickSpacingPx: 80,
            clip: true,
            color: [0, 0, 0],
            fontSizePx: 11,
            tickOffsetPx: 2,
            tickSizePx: 2,
        });
        _this.xAxis.minDisplay = 0;
        _this.xAxis.maxDisplay = Infinity;
        _this.xAxis.y = -2;
        _this.xAxis.h = _this.xAxisHeight;
        _this.xAxis.originY = -1;
        _this.xAxis.z = 20;
        _this.fillX(_this.xAxis);
        _this.add(_this.xAxis);
        // add solid a white background to XAxis so that content is hidden underneath
        var xAxisBg = new Rect_1.default(0, _this.xAxisHeight, [1, 1, 1, 1]);
        xAxisBg.z = 10;
        xAxisBg.originY = -1;
        xAxisBg.y = -_this.spacing.y;
        _this.fillX(xAxisBg);
        _this.add(xAxisBg);
        _this.resizeHandle = new Rect_1.default(0, 0, [1, 0, 0, 1]);
        _this.resizeHandle.originX = -0.5;
        _this.resizeHandle.relativeX = 1;
        _this.resizeHandle.relativeH = 1;
        _this.resizeHandle.w = _this.spacing.x;
        _this.resizeHandle.z = 1;
        _this.resizeHandle.render = false;
        _this.setResizable(false);
        _this.setDataSource(dataSource);
        return _this;
    }
    Object.defineProperty(Panel.prototype, "closable", {
        get: function () { return this._closable; },
        set: function (v) {
            this._closable = v;
            this.updatePanelHeader();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Panel.prototype, "closing", {
        get: function () { return this._closing; },
        set: function (v) {
            this._closing = v;
            this.updatePanelHeader();
        },
        enumerable: true,
        configurable: true
    });
    Panel.prototype.applyStyle = function (styleProxy) {
        this.xAxis.color = styleProxy.getColor('color') || this.xAxis.color;
        this.xAxis.fontSizePx = styleProxy.getNumber('font-size') || this.xAxis.fontSizePx;
    };
    Panel.prototype.setResizable = function (v) {
        // handle should only be in the scene-graph if it's resizable
        this.remove(this.resizeHandle);
        if (v)
            this.add(this.resizeHandle);
        this.resizeHandle.cursorStyle = v ? 'col-resize' : null;
        this.resizeHandle.color = v ? [0, 1, 0, 1] : [0.3, 0.3, 0.3, 1];
    };
    Panel.prototype.addTrackView = function (trackView) {
        trackView.addInteractionListener('dragstart', this.onTrackDragStart);
        trackView.addInteractionListener('dragmove', this.onTrackDragMove);
        trackView.addInteractionListener('dragend', this.onTrackDragEnd);
        trackView.addInteractionListener('pointerup', this.onTrackDragEnd);
        trackView.addInteractionListener('wheel', this.onTrackWheel);
        trackView.addInteractionListener('pointermove', this.onTrackPointerMove);
        trackView.addInteractionListener('pointerleave', this.onTrackLeave);
        trackView.setDataSource(this.dataSource);
        trackView.setContig(this.contig);
        trackView.setRange(this.x0, this.x1);
        this.fillX(trackView);
        this.add(trackView);
        this.trackViews.add(trackView);
    };
    Panel.prototype.removeTrackView = function (trackView) {
        trackView.removeInteractionListener('dragstart', this.onTrackDragStart);
        trackView.removeInteractionListener('dragmove', this.onTrackDragMove);
        trackView.removeInteractionListener('dragend', this.onTrackDragEnd);
        trackView.removeInteractionListener('pointerup', this.onTrackDragEnd);
        trackView.removeInteractionListener('wheel', this.onTrackWheel);
        trackView.removeInteractionListener('pointermove', this.onTrackPointerMove);
        trackView.removeInteractionListener('pointerleave', this.onTrackLeave);
        this.remove(trackView);
        this.trackViews.delete(trackView);
    };
    Panel.prototype.setDataSource = function (dataSource) {
        var _this = this;
        var e_4, _a;
        this.dataSource = dataSource;
        this._dataSourceId++;
        try {
            for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trackView = _c.value;
                trackView.setDataSource(dataSource);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        this.setAvailableContigs([]);
        var currentDataSourceId = this._dataSourceId;
        this.dataSource.getContigs().then(function (contigs) {
            if (_this._dataSourceId !== currentDataSourceId)
                return;
            _this.setAvailableContigs(contigs);
        });
    };
    Panel.prototype.setContig = function (contig) {
        var e_5, _a;
        this.contig = contig; // override readonly
        try {
            for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                var track = _c.value;
                track.setContig(contig);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        this.updatePanelHeader();
    };
    Panel.prototype.setRange = function (x0, x1, animate) {
        if (animate === void 0) { animate = false; }
        // if range is not a finite number then default to current values
        x0 = isFinite(x0) ? x0 : this.x0;
        x1 = isFinite(x1) ? x1 : this.x1;
        x0 = Math.min(x0, x1);
        x1 = Math.max(x0, x1);
        // if range is below allowed minimum, override without changing center
        var span = x1 - x0;
        if (span < this.minRange) {
            var midIndex = (x0 + x1) * 0.5;
            x0 = midIndex - this.minRange * 0.5;
            x1 = midIndex + this.minRange * 0.5;
            span = this.minRange;
        }
        if (animate) {
            var t = 10000;
            var criticalFriction = (Math.sqrt(t) * 2);
            var f = criticalFriction * 3;
            Animator_1.default.springTo(this._rangeAnimationObject, { x0: x0, x1: x1 }, { tension: t, friction: f });
        }
        else {
            Animator_1.default.stop(this._rangeAnimationObject);
            this._rangeAnimationObject.x0 = x0;
            this._rangeAnimationObject.x1 = x1;
        }
    };
    Panel.prototype.setAvailableContigs = function (contigs) {
        this.availableContigs = contigs;
        this.updatePanelHeader();
    };
    Panel.prototype.getFormattedContig = function (contigId) {
        // determine a human-friendly name for the contig
        var availableContig = this.availableContigs.find(function (c) { return c.id === contigId; });
        if (availableContig != null) {
            if (availableContig.name != null) {
                // use user-supplied name
                return availableContig.name;
            }
            else {
                return contigId;
            }
        }
        else {
            // unknown contig
            return "" + this.contig;
        }
    };
    Panel.prototype.setSecondaryAxisPointers = function (secondaryAxisPointers) {
        var e_6, _a, e_7, _b;
        // remove any old and unused axis pointers
        for (var pointerId in this.secondaryAxisPointers) {
            if (secondaryAxisPointers[pointerId] === undefined && this.activeAxisPointers[pointerId] === undefined) {
                try {
                    for (var _c = __values(this.trackViews), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var trackView = _d.value;
                        trackView.removeAxisPointer(pointerId);
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        }
        // add or update secondary axis pointers
        for (var pointerId in secondaryAxisPointers) {
            // if this panel has this pointer as an active axis pointer, skip it
            if (this.activeAxisPointers[pointerId] !== undefined) {
                continue;
            }
            var absX = secondaryAxisPointers[pointerId];
            var span = this.x1 - this.x0;
            var fractionX = (absX - this.x0) / span;
            this.secondaryAxisPointers[pointerId] = absX;
            try {
                for (var _e = __values(this.trackViews), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var trackView = _f.value;
                    trackView.setAxisPointer(pointerId, fractionX, TrackObject_1.AxisPointerStyle.Secondary);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
    };
    Panel.prototype.setRangeImmediate = function (x0, x1) {
        var e_8, _a;
        var l = this.applyLimits(x0, x1);
        x0 = l.x0;
        x1 = l.x1;
        this.x0 = x0;
        this.x1 = x1;
        // control axis text length by number of visible base pairs
        // when viewing a small number of bases the exact span is likely required
        var span = x1 - x0;
        if (span < 150) {
            this.xAxis.maxTextLength = Infinity;
        }
        else if (span < 1e5) {
            this.xAxis.maxTextLength = 6;
        }
        else {
            this.xAxis.maxTextLength = 4;
        }
        this.xAxis.setRange(x0, x1);
        try {
            for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                var track = _c.value;
                track.setRange(x0, x1);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_8) throw e_8.error; }
        }
        this.updatePanelHeader();
    };
    Panel.prototype.applyLimits = function (x0, x1) {
        var e_9, _a;
        if (this.clampToTracks) {
            x0 = Math.max(0, x0);
            x1 = Math.max(0, x1);
            var allMaxX = -Infinity;
            try {
                for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var trackView = _c.value;
                    var maxX = trackView.getTileLoader().maximumX;
                    if (isFinite(maxX)) {
                        allMaxX = Math.max(maxX, allMaxX);
                    }
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
            if (allMaxX > 0) {
                x0 = Math.min(allMaxX, x0);
                x1 = Math.min(allMaxX, x1);
            }
        }
        return { x0: x0, x1: x1 };
    };
    Panel.prototype.setActiveAxisPointer = function (e) {
        var e_10, _a;
        var fractionX = e.fractionX;
        var span = this.x1 - this.x0;
        var axisPointerX = span * fractionX + this.x0;
        this.activeAxisPointers[e.pointerId] = axisPointerX;
        try {
            for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tile = _c.value;
                tile.setAxisPointer(e.pointerId.toString(), fractionX, TrackObject_1.AxisPointerStyle.Active);
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
        // broadcast active axis pointer change
        this.eventEmitter.emit('axisPointerUpdate', this.activeAxisPointers);
    };
    Panel.prototype.removeActiveAxisPointer = function (e) {
        var e_11, _a;
        if (this.activeAxisPointers[e.pointerId] === undefined) {
            return;
        }
        delete this.activeAxisPointers[e.pointerId];
        try {
            for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trackView = _c.value;
                trackView.removeAxisPointer(e.pointerId.toString());
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_11) throw e_11.error; }
        }
        this.eventEmitter.emit('axisPointerUpdate', this.activeAxisPointers);
    };
    Panel.prototype.fillX = function (obj) {
        obj.x = this.spacing.x * 0.5;
        obj.originX = 0;
        obj.relativeX = 0;
        obj.relativeW = 1;
        obj.w = -this.spacing.x;
    };
    Panel.prototype.updatePanelHeader = function () {
        var _this = this;
        var rangeString = Axis_1.default.formatValue(this.x0, 8) + "bp to " + Axis_1.default.formatValue(this.x1, 8) + "bp";
        var startBp = Math.floor(this.x0).toFixed(0);
        var endBp = Math.ceil(this.x1).toFixed(0);
        var rangeSpecifier = this.contig + ":" + startBp + "-" + endBp;
        this.header.content = React.createElement(PanelHeader, { panel: this, contig: this.getFormattedContig(this.contig), rangeString: rangeString, rangeSpecifier: rangeSpecifier, enableClose: this._closable && !this.closing, enableContigNavigation: this.availableContigs != null && (this.availableContigs.length > 1), onClose: this.onClose, isEditing: this.isEditing, onEditCancel: function () { return _this.finishEditing(); }, onEditSave: function (rangeSpecifier) { return _this.finishEditing(rangeSpecifier); }, onEditStart: function () { return _this.startEditing(); }, onNextContig: function () {
                var contig = _this.availableContigAtOffset(_this.contig, 1);
                _this.setContig(contig);
                var idx = _this.availableContigs.findIndex(function (c) { return c.id === contig; });
                if (idx !== -1) {
                    _this.setRange(_this.availableContigs[idx].startIndex, _this.availableContigs[idx].span);
                }
            }, onPreviousContig: function () {
                var contig = _this.availableContigAtOffset(_this.contig, -1);
                _this.setContig(contig);
                var idx = _this.availableContigs.findIndex(function (c) { return c.id === contig; });
                if (idx !== -1) {
                    _this.setRange(_this.availableContigs[idx].startIndex, _this.availableContigs[idx].span);
                }
            } });
    };
    Panel.prototype.finishEditing = function (rangeSpecifier) {
        this.isEditing = false;
        if (rangeSpecifier) {
            this.setRangeUsingRangeSpecifier(rangeSpecifier);
        }
        this.updatePanelHeader();
    };
    Panel.prototype.startEditing = function () {
        this.isEditing = true;
        this.updatePanelHeader();
    };
    Panel.prototype.setRangeUsingRangeSpecifier = function (specifier) {
        // @! this could be improved to be more robust (for example, omitting contig should use current contig, etc)
        try {
            var parts = specifier.split(':');
            var contig = parts[0];
            // make chrx to chrX
            var chromosomeContigMatch = /chr(.*)$/.exec(contig);
            if (chromosomeContigMatch) {
                contig = 'chr' + chromosomeContigMatch[1].toUpperCase();
            }
            var ranges = parts[1].split('-');
            this.setContig(contig);
            this.setRange(parseFloat(ranges[0].replace(/,/g, '')), parseFloat(ranges[1].replace(/,/g, '')));
        }
        catch (e) {
            console.error("Could not parse specifier \"" + specifier + "\"");
        }
    };
    return Panel;
}(Object2D_1.default));
exports.Panel = Panel;
var PanelEvent = /** @class */ (function () {
    function PanelEvent(type, panel) {
        var _this = this;
        this.type = type;
        this.panel = panel;
        this.preventDefault = function () {
            _this._defaultPrevented = true;
        };
        this._defaultPrevented = false;
    }
    Object.defineProperty(PanelEvent.prototype, "defaultPrevented", {
        get: function () {
            return this._defaultPrevented;
        },
        enumerable: true,
        configurable: true
    });
    return PanelEvent;
}());
exports.PanelEvent = PanelEvent;
var SelectRegionEvent = /** @class */ (function (_super) {
    __extends(SelectRegionEvent, _super);
    function SelectRegionEvent(panel, contig, 
    /**
     * Selection start in base-pairs
     */
    x0, 
    /**
     * Selection end in base-pairs
     */
    x1, 
    /**
     * Location of selection start relative to the panel view, where 0 left most edge and 1 is rightmost
     */
    x0ViewFraction, 
    /**
     * Location of selection end relative to the panel view, where 0 left most edge and 1 is rightmost
     */
    x1ViewFraction) {
        var _this = _super.call(this, 'select-region', panel) || this;
        _this.contig = contig;
        _this.x0 = x0;
        _this.x1 = x1;
        _this.x0ViewFraction = x0ViewFraction;
        _this.x1ViewFraction = x1ViewFraction;
        return _this;
    }
    return SelectRegionEvent;
}(PanelEvent));
exports.SelectRegionEvent = SelectRegionEvent;
var PanelHeader = /** @class */ (function (_super) {
    __extends(PanelHeader, _super);
    function PanelHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PanelHeader.prototype.render = function () {
        var _this = this;
        var headerContents = null;
        var headerContainerStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        };
        var headerStyle = {
            marginTop: 8,
            marginLeft: 8
        };
        var iconViewBoxSize = '0 0 32 32';
        var closeIcon = this.props.enableClose ? (React.createElement("div", { style: {
                position: 'absolute',
                right: 0
            } },
            React.createElement(IconButton_1.default, { onClick: function () { return _this.props.onClose(_this.props.panel); }, color: "inherit" },
                React.createElement(Close_1.default, null)))) : null;
        var previousIcon = (React.createElement("div", { style: {
                position: 'absolute',
                left: 0
            } },
            React.createElement(IconButton_1.default, { onClick: function () { return _this.props.onPreviousContig(_this.props.panel); }, color: "inherit" },
                React.createElement(ChevronLeft_1.default, null))));
        var nextIcon = (React.createElement("div", { style: {
                position: 'absolute',
                right: 0
            } },
            React.createElement(IconButton_1.default, { onClick: function () { return _this.props.onNextContig(_this.props.panel); }, color: "inherit" },
                React.createElement(ChevronRight_1.default, null))));
        if (this.props.isEditing) {
            var userRangeSpecifier_1 = this.props.rangeSpecifier;
            headerContents = (React.createElement("div", { style: headerContainerStyle },
                React.createElement("input", { autoFocus: true, onChange: function (e) { return userRangeSpecifier_1 = e.target.value; }, onKeyDown: function (e) {
                        if (e.key === 'Enter') {
                            _this.props.onEditSave(userRangeSpecifier_1);
                        }
                    }, type: "text", defaultValue: this.props.rangeSpecifier, style: {
                        maxWidth: '200px',
                        width: '100%',
                    } }),
                React.createElement("span", { style: headerStyle },
                    React.createElement(Cancel_1.default, { onClick: function () { return _this.props.onEditCancel(); }, viewBox: iconViewBoxSize })),
                React.createElement("span", { style: headerStyle },
                    React.createElement(Check_1.default, { onClick: function () { return _this.props.onEditSave(userRangeSpecifier_1); }, viewBox: iconViewBoxSize })),
                closeIcon));
        }
        else {
            headerContents = (React.createElement("div", { style: headerContainerStyle },
                this.props.enableContigNavigation ? previousIcon : null,
                React.createElement("span", { onClick: function () { return _this.props.onEditStart(); } },
                    React.createElement("b", null, this.props.contig),
                    " ",
                    this.props.rangeString),
                React.createElement("span", { style: headerStyle, onClick: function () { return _this.props.onEditStart(); } },
                    React.createElement(Edit_1.default, { viewBox: iconViewBoxSize })),
                this.props.enableContigNavigation ? nextIcon : null));
        }
        return React.createElement("div", { className: "hpgv_ui-block hpgv_panel-header", style: {
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                userSelect: 'none',
            } },
            React.createElement("div", { style: {
                    position: 'absolute',
                    width: '100%',
                    textAlign: 'center',
                    top: '50%',
                    transform: 'translate(0, -50%)',
                    whiteSpace: 'nowrap',
                    cursor: 'pointer',
                } }, headerContents));
    };
    return PanelHeader;
}(React.Component));
exports.default = Panel;
